import { useAuthStore } from '@tundr/auth';
import { LifecyclePhase, useLifecycleHooksStore } from '@tundr/lifecycle-hooks';
import { useLocale } from '@tundr/i18n';
import { ToastVariant } from '@tundr/theme';
import { useToast } from '@tundr/toast';
import { useConfirmNavigationGuard } from '@tundr/routing';
import { useRouter } from 'vue-router';
import { appRoutesDictionary } from '@bo/core/router/routes.dictionary';

export const useLogout = () => {
  const { t } = useLocale('common');
  const authStore = useAuthStore();
  const lifecycleHooks = useLifecycleHooksStore();
  const router = useRouter();
  const { show } = useToast();
  const { confirmNavigationGuard } = useConfirmNavigationGuard();

  const onLogout = async () => {
    const isExitConfirmed = await confirmNavigationGuard();

    if (!isExitConfirmed) {
      return;
    }

    try {
      await lifecycleHooks.run(LifecyclePhase.LOGOUT);
    } catch (err) {
      console.error(
        '[logout] lifecycle hook failed, forcing session teardown',
        err,
      );
    } finally {
      authStore.logout();
      lifecycleHooks.reset(LifecyclePhase.SESSION_INIT);
      show({
        message: t('profile_menu.actions.logout.success.title'),
        description: t('profile_menu.actions.logout.success.description'),
        variant: ToastVariant.SUCCESS,
      });
      router.replace({ name: appRoutesDictionary.auth.login.name });
    }
  };

  return {
    onLogout,
  };
};
